<template>
  <v-container class="mj_dialog_container">
    <v-overlay
      :value="loading_overlay"
      style="
        min-width: 100%;
        min-height: 100%;
        left: 0px;
        z-index: 9999;
        top: 0px;
      "
    >
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-form
      class="mj_dialog_form"
      ref="form"
      v-model="valid"
      :lazy-validation="lazy"
    >
      <v-container>
        <div>Scadenza ID:{{ $route.params.id }}</div>
        <div class="overline secondary--text">
          Collegato a Pratica: <span class='font-weight-bold'>{{ pratica.nome ? pratica.nome : "" }}</span>
        </div>
        <v-row>
          <v-col cols="12" md="7">
            <MjDateTimePicker
              label="Data Scadenza"
              v-model="form.data.val"
              time_model_format="HH:mm:ss"
              time_display_format="HH:mm"
              date_model_format="YYYY-MM-DD"
              mode="date"
              date_display_format="DD-MM-YYYY"
              :rules="[rules.required]"
            >
            </MjDateTimePicker>
          </v-col>

          <v-col cols="12" md="5">
            <v-autocomplete
              label="Responsabile"
              v-model="form.users_id.val"
              :item-text="(item) => `${item.email} ${item.name}`"
              item-value="id"
              :items="this.selects.users_id"
              cache-items
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="3">
            {{form.stato.val}}
            <v-switch
              label="Conclusa"
              v-model="form.stato.val"
              :true-value="1"
              :false-value="0"
            >
            </v-switch>
          </v-col>
          <v-col cols="12" md="8">
            <v-text-field
              label="Descrizione"
              v-model="form.descrizione.val"
              :rules="[rules.max(255)]"
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-textarea label="Nota" v-model="form.nota.val" rows="2">
            </v-textarea>
          </v-col>
        </v-row>
        <v-list
          outlined
          class="my-0 py-0"
          v-if="Object.keys(this.form.attivita_riferimento.val).length > 0"
        >
          <v-list-item class="teal lighten-1">
            <v-list-item-title class="white--text"
              >Attività di Riferimento</v-list-item-title
            >
          </v-list-item>

          <v-list-item
            v-if="
              form.attivita_riferimento.val.attivita_collegate == null ||
              form.attivita_riferimento.val.attivita_collegate.length == 0
            "
          >
            <v-icon>mdi-text-box-outline</v-icon>
            <v-list-item-title class="ml-2">
              {{ form.attivita_riferimento.val.cod }}
              {{ form.attivita_riferimento.val.descrizione }}
            </v-list-item-title>
          </v-list-item>

          <v-list-group
            v-else
            :value="true"
            color="blue"
            prepend-icon="mdi-text-box-multiple-outline"
          >
            <template v-slot:activator>
              <v-list-item-title>
                {{ form.attivita_riferimento.val.cod }}
                {{ form.attivita_riferimento.val.descrizione }}
              </v-list-item-title>
            </template>
            <template
              two-line
              v-for="(attivita_has, index) in form.attivita_riferimento.val
                .attivita_collegate"
            >
              <v-list-item :key="index">
                <v-list-item-avatar>
                  <v-icon>mdi-text-box-outline</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{
                    attivita_has.attivita.cod
                  }}</v-list-item-title>
                  <v-list-item-subtitle
                    >{{ attivita_has.attivita.descrizione }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-spacer></v-spacer>
                <v-list-item-action>
                  {{ attivita_has.offset_day_scadenza }}gg
                </v-list-item-action>
              </v-list-item>
              <v-divider
                v-if="
                  index !==
                  form.attivita_riferimento.val.attivita_collegate.length - 1
                "
                :key="'divider_' + index"
              ></v-divider>
            </template>
          </v-list-group>
        </v-list>

        <v-row justify="start" align="end" v-show="this.$route.params.id">
          <v-col>
            <v-btn
              depressed
              outlined
              color="secondary"
              class="mt-2 mb-1"
              @click="clonaScadenza"
            >
              Clona
              <v-icon>mdi-briefcase-outline</v-icon>
            </v-btn>
            <v-btn
                depressed
                outlined
                color="primary"
                class="mt-2 ml-2 mb-1"
                @click="$router.push({ name: 'SchedaPratica', params: { id: form.pratiche_id.val } });"
            >
              Apri Pratica
              <v-icon>mdi-calendar-blank-multiple</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-alert
          :type="gcal_sync_status_icon"
          prominent
          outlined
          dense
          v-show="this.$route.params.id"
        >
          <v-row align="center">
            <v-col class="">
              <h4>Google Calendar</h4>
              Ultima Sincronizzazione: {{ gcal_last_sync }}
              <v-btn
                  depressed
                  class="white--text ml-2 mt-0"
                  color="red"
                  @click="syncGCal"

              >
                Sincronizza
                <v-icon class="ml-2">mdi-calendar-arrow-right</v-icon>
              </v-btn>
            </v-col
            >

          </v-row>
        </v-alert>

        <SchedaToolbar

          :error_show="error_show"
          :error_text="error_text"
          :edit_not_saved="edit_not_saved"
          :edit_mode="editMode"
          :new_button_visibile="false"
          v-on:newItemClick="customNewItem()"
          v-on:saveItemClick="saveItem()"
          v-on:goBackClick="goBack()"
        />
      </v-container>
    </v-form>
  </v-container>
</template>
<style>
</style>

<script>
import schedaMixin from "@/mixins/SchedaMixin.js";
import ValidationRulesMixin from "@/mixins/ValidationRulesMixin.js";
import SchedaToolbar from "@/components/SchedaToolbar.vue";
import MjDateTimePicker from "@/components/MjDateTimePicker.vue";
import moment from "moment";
import mj_axios from "@/mj_axios.js";

export default {
  name: "SchedaScadenza",
  mixins: [schedaMixin, ValidationRulesMixin],
  components: { SchedaToolbar, MjDateTimePicker },
  computed: {
    dialogMode: function () {
      return this.$route.query.dialog_mode;
    },
    gcal_last_sync: function () {
      return this.form.gcal_last_sync.val
        ? moment(this.form.gcal_last_sync.val).format("DD-MM-YYYY HH:mm")
        : "Nessun sync";
    },
    gcal_sync_status_icon: function () {
      if (this.gcal_sync_status > 0) return "success";
      if (this.gcal_sync_status < 0) return "error";
      else return "info";
    },
  },

  data: () => ({
    // attivita_riferimento: {},
    gcal_sync_status: "",
    pratica: {},
    form: {
      attivita_riferimento: { type: "object", val: {}, default_val: {} },
      descrizione: { type: "string", val: "", default_val: "" },
      users_id: {
        type: "integer",
        val: "",
        default_val: "",
        loadSelect: true,
        apiUrl: "/api/user/users",
      },
      stato: { type: "integer", val: "", default_val: 0 },
      data: { type: "datetime", val: "", default_val: "" },
      gcal_last_sync: { type: "datetime", val: "", default_val: "" },
      nota: { type: "text", val: "", default_val: "" },
      // attivita_id: {
      //   type: "integer",
      //   val: "",
      //   default_val: "",
      //   loadSelect: true,
      //   apiUrl: "/api/attivita",
      // },
      pratiche_id: {
        type: "integer",
        val: "",
        default_val: "",
        loadSelect: false,
        apiUrl: "/api/pratiche",
      },
    },
    apiUrl: "/api/scadenze",
  }),

  methods: {
    init() {
      schedaMixin.methods.init.call(this).then(() => {

        // this.form.stato.val = 0;

        if (this.$route.query.pratica_id) {
          this.form.pratiche_id.val = this.$route.query.pratica_id;
        }

        if (this.form.pratiche_id.val)
        { this.loadPratica(this.form.pratiche_id.val);}

        const copy_attivita_id = this.$route.query.copy_attivita_id;

        if (copy_attivita_id) {
          
          
          this.loading_overlay = true;
          mj_axios
            .get("/api/attivita/" + copy_attivita_id)
            .then((response) => {
              if (response.data) {
                this.form.attivita_riferimento.val = response.data.data;
                this.form.descrizione.val = this.form.attivita_riferimento.val.descrizione;
                this.form.users_id.val = this.form.attivita_riferimento.val.responsabile_id_default;
                this.form.nota.val = this.form.attivita_riferimento.val.nota;
                this.form.attivita_id = {};
                this.form.attivita_id.val = this.form.attivita_riferimento.val.id;
              }
            })
            .catch((e) => {
              // const status = (e.response) ? e.response.status : null;
              let message = e.response && e.response.data ? e.response.data.message : null;
              this.error_show = true;
              this.error_text = `Errore nel Caricamento Attivita di Riferimento ${
                message ? message : ""
              }`;
            })
            .then(() => {
              this.loading_overlay = false;
            });
        }
      });
    },
    customNewItem(){
      // console.log('custom new item ' + this.form.attivita_riferimento.val.id + " " + this.form.pratiche_id.val);
      // console.log(JSON.stringify(this.$route.query));
      schedaMixin.methods.newItem.call(this)
      // schedaMixin.methods.init.call(this)
    },
    loadPratica(id) {
      mj_axios
        .get("/api/pratica/" + id)
        .then((response) => {
          if (response.data) {
            this.pratica = (response.data.data);
            
          }
        })
        .catch((e) => {
          // const status = (e.response) ? e.response.status : null;
          let message =
            e.response && e.response.data ? e.response.data.message : null;
          this.error_show = true;
          this.error_text = `Errore nel Caricamento Attivita di Riferimento ${
            message ? message : ""
          }`;
        });
    },
    syncGCal: function () {
      this.saveItem().then(() => {
        this.loading_overlay = true;
        this.error_show = false;

        let params = { ids: [this.$route.params.id] };
        const axios_promise = mj_axios.post("/api/sync_gcal_scadenze", params);

        axios_promise
          .then((response) => {
            if (response && response.data) {
              const scadenze = response.data;

              //nei data si trovano le scadenze aggiornate
              //in questo caso l'array dovrebbe essere formata da un solo elemento
              Object.values(scadenze).forEach((scadenza) => {
                if (scadenza.id == this.$route.params.id) {
                  this.form.gcal_last_sync.val = scadenza.gcal_last_sync;
                  this.gcal_sync_status = scadenza.gcal_sync_status;

                  if (scadenza.gcal_sync_status == -1) {
                    this.error_show = true;
                    this.error_text =
                      "Errore nella sincronizzazione con Google Calendar";
                  } else if (scadenza.gcal_sync_status == -2) {
                    this.error_show = true;
                    this.error_text =
                      "Richiedi all'utente responsabile della scadenza di concedere i permessi per Google Calendar";
                  }
                }
              });
            }
          })

          .catch((e) => {
            // const status = e.response ? e.response.status : null;
            let message =
              e.response && e.response.data ? e.response.data.message : null;

            this.error_show = true;
            this.error_text = `Errore nella Sincronizzazione dati  ${
              message ? message : ""
            }`;
          })
          .then(() => {
            this.loading_overlay = false;
          });
      });
    },
    clonaScadenza: function () {
      this.saveItem().then(() => {
        this.loading_overlay = true;
        this.error_show = false;

        const axios_promise = mj_axios.post(
          `/api/clona_scadenza/${this.$route.params.id}`
        );

        axios_promise
          .then((response) => {
            if (response && response.data) {
              const nuova_scadenza = response.data;
              this.$router.replace({
                name: this.newViewName,
                params: { id: nuova_scadenza.id },
              });
            }
          })
          .catch((e) => {
            // const status = e.response ? e.response.status : null;
            let message =
              e.response && e.response.data ? e.response.data.message : null;

            this.error_show = true;
            this.error_text = `Errore nella Clonazione della scadenza  ${
              message ? message : ""
            }`;
          })
          .then(() => {
            this.loading_overlay = false;
          });
      });
    },
  },
};
</script>
